import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Channel } from "../../Channel";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import { CreateCampaignAwardedData } from "../../../types/campaignAwarded";

export function Actions() {
  const formik = useFormikContext<CreateCampaignAwardedData>();

  return (
    <Stack spacing={4}>
      <Typography color="primary">Ações</Typography>
      <RadioGroup
        value={formik.values.action}
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={(_, value) => formik.setFieldValue("action", value)}
      >
        <Grid container spacing={2}>
          <Grid display="flex" item xs={4}>
            <Channel
              value="sorteio"
              title="Sorteio"
              subtitle="Realize sorteios para aumentar o engajamento do seu cliente"
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </Stack>
  );
}
